import React from 'react';
import { Users, Activity, Trophy, ShieldUser, Clock } from 'lucide-react';
import '../../../../../styles/components/auciton-overview.scss';
import { withRouter } from '../../../../../hoc/withRouter';

class AuctionOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPeriod: 'Last 30 Days',
      isDropdownOpen: false,
    };
  }

  toggleDropdown = () => {
    this.setState((prev) => ({ isDropdownOpen: !prev.isDropdownOpen }));
  };

  selectPeriod = (period) => {
    this.setState({ selectedPeriod: period, isDropdownOpen: false });
  };

  formatNumber = (num) => (num !== null && num !== undefined ? num.toLocaleString('en-US') : 0);

  handleCardClick = (path, disabled, status = null, type = null) => {
    if (disabled) return; // prevent click when disabled
    const { startDate, endDate } = this.props;
    const params = new URLSearchParams();

    if (startDate) params.set('startDate', startDate);
    if (endDate) params.set('endDate', endDate);
    if (status) params.set('status', status);
    if (type) params.set('type', type);

    const queryString = params.toString() ? `?${params.toString()}` : '';

    console.log(queryString, '@query');

    this.props.navigate(`${path}${queryString}`);
  };

  renderSkeleton = () => {
    // 5 placeholder cards
    return (
      <div className="auction-overview">
        {/* Skeleton Header */}
        <div className="overview-header">
          <div className="header-left">
            <h2 className="overview-title">Auction Overview</h2>
          </div>
        </div>

        {/* Skeleton Metric Cards */}
        <div className="metrics-grid">
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="metric-card skeleton-card">
              <div className="skeleton-icon"></div>
              <div className="skeleton-label"></div>
              <div className="skeleton-value"></div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  render() {
    const {
      enrollmentBidders,
      strategyEnrollments,
      previousAuctions,
      runningAuctions,
      totalWinners,
      loading,
    } = this.props;

    if (loading) return this.renderSkeleton();

    const metricsData = [
      {
        label: 'Enrollment Bidders',
        value: enrollmentBidders,
        icon: Users,
        color: 'blue',
        path: '/enrollment-overview',
        type: 'paid',
      },
      {
        label: 'Strategy Enrollments',
        value: strategyEnrollments,
        icon: ShieldUser,
        color: 'purple',
        path: '/enrollment-overview',
        type: 'stratergy',
      },
      {
        label: 'Previous Auctions',
        value: previousAuctions,
        icon: Clock,
        color: 'gray',
        path: '/auction-overview',
        status: 'E',
      },
      {
        label: 'Running Auctions',
        value: runningAuctions,
        icon: Activity,
        color: 'orange',
        path: '/auction-overview',
        status: 'A',
      },
      {
        label: 'Total Winners',
        value: totalWinners,
        icon: Trophy,
        color: 'gold',
        path: '/winner-overview',
      },
    ];

    return (
      <div className="auction-overview">
        <div className="overview-header">
          <div className="header-left">
            <h2 className="overview-title">Auction Overview</h2>
          </div>
        </div>

        <div className="metrics-grid">
          {metricsData.map((metric, index) => {
            const IconComponent = metric.icon;
            const isDisabled = !metric.value || metric.value === 0;

            return (
              <div
                key={index}
                className={`metric-card ${isDisabled ? 'disabled' : ''}`}
                onClick={() =>
                  this.handleCardClick(metric.path, isDisabled, metric.status, metric.type)
                }
              >
                <div className="metric-header">
                  <div className={`metric-icon-wrapper ${metric.color}`}>
                    <IconComponent className="metric-icon" size={24} />
                  </div>
                </div>
                <div className="metric-label">{metric.label}</div>
                <div className="metric-value">{this.formatNumber(metric.value)}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default withRouter(AuctionOverview);
